import { render, staticRenderFns } from "./twitch.vue?vue&type=template&id=4e031db3"
import script from "./twitch.vue?vue&type=script&lang=js"
export * from "./twitch.vue?vue&type=script&lang=js"
import style0 from "./twitch.vue?vue&type=style&index=0&id=4e031db3&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports